import { Loader2Icon } from "lucide-react";

import { cn } from "@krea/shared/utils";

const sizeMap = {
  sm: "size-4",
  md: "size-6",
  lg: "size-12",
  xl: "size-14",
  xxl: "size-24",
} as const;

type SpinnerSize = keyof typeof sizeMap;

function Spinner({
  className,
  iconClassName,
  size = "xl",
}: {
  className?: string;
  iconClassName?: string;
  size?: SpinnerSize;
}) {
  return (
    // Two class props on purpose: the wrapper is what callers position, size and
    // paint (full-page overlays pass `fixed h-full w-full bg-white`), while the
    // icon is sized independently by sizeMap — so a `size-*` on `className` never
    // reached it. `iconClassName` is that missing seam; cn is twMerge, so it wins
    // over the sizeMap default. Needed because Button and the lender call sites
    // want sizes (size-3/5/6/10) that sizeMap does not express.
    <div
      className={cn("flex items-center justify-center text-primary", className)}
    >
      <Loader2Icon
        role="status"
        aria-label="Loading"
        strokeWidth={2.5}
        className={cn(sizeMap[size], "animate-spin", iconClassName)}
      />
    </div>
  );
}

export type { SpinnerSize };
export { Spinner };
